import type { IPermissionGroup } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export const PERMISSION_GROUPS_QUERY_KEY = "usePermissionGroupsQuery";

const PAGE_SIZE = 100;

export const usePermissionGroupsQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery<IPermissionGroup[]>({
    queryKey: [PERMISSION_GROUPS_QUERY_KEY, apiClient.slug],
    queryFn: async () => {
      const res = await apiClient.permissionGroups.list({ limit: PAGE_SIZE });
      return res.result?.elements ?? [];
    },
    enabled: !!apiClient.slug
  });
};
